import { useState, useMemo } from 'react'
import { theatreRoomEventsMockData } from '../utils/mockdata'

const useEventData = () => {
  const [searchText, setSearchText] = useState('')
  const [roomFilter, setRoomFilter] = useState('all')
  const [eventTypeFilter, setEventTypeFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)

  // Get unique values for filters
  const theatreRooms = useMemo(() => {
    return [...new Set(theatreRoomEventsMockData.map((event) => event.theatreRoom))].sort()
  }, [])

  const eventTypes = useMemo(() => {
    return [...new Set(theatreRoomEventsMockData.map((event) => event.eventType))].sort()
  }, [])

  const eventCategories = useMemo(() => {
    return [...new Set(theatreRoomEventsMockData.map((event) => event.eventCategory))].sort()
  }, [])

  // Filter the data based on search and filters
  const filteredData = useMemo(() => {
    return theatreRoomEventsMockData.filter((event) => {
      // Text search
      const textMatch =
        searchText === '' ||
        event.eventDetails.toLowerCase().includes(searchText.toLowerCase()) ||
        (event.patientName && event.patientName.toLowerCase().includes(searchText.toLowerCase())) ||
        event.theatreRoom.toLowerCase().includes(searchText.toLowerCase()) ||
        event.eventId.toLowerCase().includes(searchText.toLowerCase()) ||
        (event.responsibleStaff && event.responsibleStaff.toLowerCase().includes(searchText.toLowerCase()))

      // Room filter
      const roomMatch = roomFilter === 'all' || event.theatreRoom === roomFilter

      // Event type filter
      const typeMatch = eventTypeFilter === 'all' || event.eventType === eventTypeFilter

      // Status filter
      const statusMatch = statusFilter === 'all' || event.status === statusFilter

      // Date range filter
      let dateMatch = true
      if (dateRange && dateRange[0] && dateRange[1]) {
        const eventDate = new Date(event.eventStart)
        const startDate = dateRange[0].startOf('day').toDate()
        const endDate = dateRange[1].endOf('day').toDate()
        dateMatch = eventDate >= startDate && eventDate <= endDate
      }

      return textMatch && roomMatch && typeMatch && statusMatch && dateMatch
    })
  }, [searchText, roomFilter, eventTypeFilter, statusFilter, dateRange])

  // Group events by theatre room for timeline view
  const eventsByRoom = useMemo(() => {
    return theatreRooms
      .map((room) => {
        return {
          room,
          events: filteredData
            .filter((event) => event.theatreRoom === room)
            .sort((a, b) => new Date(a.eventStart) - new Date(b.eventStart))
        }
      })
      .filter((roomData) => roomData.events.length > 0) // Only include rooms with events
  }, [theatreRooms, filteredData])

  return {
    searchText,
    setSearchText,
    roomFilter,
    setRoomFilter,
    eventTypeFilter,
    setEventTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    theatreRooms,
    eventTypes,
    eventCategories,
    filteredData,
    eventsByRoom
  }
}

export default useEventData
